import {getTranslation} from "./get-translation";

export function createLoadingScreen(loadingId, excludedScreens = []){
	const translation = getTranslation(loadingId);
	return {
		loadingId,
		loadingMessage: translation,
		excludedScreens
	}
}